import { createSlice, createAsyncThunk, compose } from '@reduxjs/toolkit';
import axios from 'axios';

import { baseURL } from '../config';

const initialState = {
  token: typeof window !== 'undefined' && localStorage.getItem('token'),
  isAuthenticated: false,
  isLoading: false,
  error: null,
  resetRequestSuccess: false,
  users: {
    property: {
      empty: false,
      first: false,
      last: false,
      page_number: 0,
      page_size: 0,
      sort: {
        empty: false,
        sorted: false,
        unsorted: false
      },
      total_elements: 0,
      total_pages: 0
    },
    data: []
  }
};

export const LoginWithEmail = createAsyncThunk('user/Login', async (args) => {
  try {
    const response = await axios.post(`${baseURL}user/login`,
      {
        "email": args.email,
        "password": args.password,
        "access": 'PAS'
      }
    );
    if (response?.data?.api.responseCode === 2250) {
      localStorage.setItem('x-auth-token', response.headers.token);
      if (args.navigate) args.navigate('/');
    }
    return response;
  } catch (error) {
    return error.response;
  }
});

export const RequestPasswordReset = createAsyncThunk('user/RequestReset', async (args) => {
  try {
    const response = await axios.post(`${baseURL}user/account/reset-password/init-token/${args.email}/PAS`);

    return response;
  } catch (error) {
    return error.response;
  }
});

export const getPASUsers = createAsyncThunk('user/getPASUsers', async () => {
  return await fetch(`${baseURL}user/profile/PAS`, {
    headers: {
      "content-type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem('x-auth-token')
    }
  })
    .then(res => res.json())
    .then(res => { console.log(res); return (res) })
    .catch(e => console.log(e))
});

export const AuthSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    logOut: (state, actions) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.token = null;
      localStorage.clear();
    },
    clearErr: (state, actions) => {
      state.error = null;
    }
  },
  extraReducers(builder) {
    builder.addCase(LoginWithEmail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(LoginWithEmail.fulfilled, (state, action) => {
      switch (action.payload?.data?.api?.responseCode) {
        case 2250:
          state.isLoading = false;
          state.isAuthenticated = true;
          state.error = null;
          localStorage.setItem('user', JSON.stringify(action.payload.data?.result));
          break;
        case 5190:
          state.isLoading = false;
          state.isAuthenticated = false;
          state.error = 'Oh! There seems to be an unexpected server issue, We are trying to fix it.';
          break;
        case 3050:
          state.isLoading = false;
          state.isAuthenticated = false;
          state.error = 'Oops! We couldn\'t find the email you entered.';
          break;
        case 4150:
          state.isLoading = false;
          state.isAuthenticated = false;
          state.error = 'The password you entered is incorrect. Please try again.';
          break;
        default:
          state.isLoading = false;
          state.isAuthenticated = false;
          state.error = 'Oh! An Unexpected error occurred, Try again or report if it persists.';
          break;
      }
    });
    builder.addCase(LoginWithEmail.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(RequestPasswordReset.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(RequestPasswordReset.fulfilled, (state, action) => {
      switch (action.payload?.data?.api?.responseCode) {
        case 2130:
          state.resetRequestSuccess = true;
          state.isLoading = false;
          state.error = null;
          break;
        case 3050:
          state.isLoading = false;
          state.error = 'User Not Found';
          break;
        default:
          state.isLoading = false;
          state.error = action.payload?.data?.message;
          break;
      }
    });
    builder.addCase(RequestPasswordReset.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getPASUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPASUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.users.data = action.payload.result;
      state.users.property = action.payload.property;
    });
    builder.addCase(getPASUsers.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});
export const { clearErr } = AuthSlice.actions
export default AuthSlice.reducer;